module.exports = __webpack_public_path__ + "static/media/no_data.398b4eea.png";